import { apiURl } from "../configuration/apiconfig";
import { fetchAndReturn } from "../utils/utility";

const getProductProfitabilityRequest = (token, date, selectedRestaurant) => {
  const organizationId = localStorage.getItem("organizationId");

  let url =
    apiURl +
    "items/getProductProfitability?organizationId=" +
    organizationId +
    "&restaurantId=" +
    selectedRestaurant +
    "&refDate=" +
    date;

  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

export { getProductProfitabilityRequest };
